module.exports = __webpack_public_path__ + "img/Facial Treatments 3.e3e3d3c7.jpg";